module.exports = __webpack_public_path__ + "assets/img/pyramid_people-2_02.42324806.png";